module.exports = __webpack_public_path__ + "static/media/Mongodb.43fd37e8.svg";